import Breadcrumbs from 'app/shared-components/marketing/Breadcrumbs';
import ArticleViewContent from 'app/shared-components/article/ArticleViewContent';
import ArticleHeaderTags from 'app/shared-components/helmet/ArticleHeaderTags';
import { useSelector, useDispatch } from 'react-redux';
import {
  selectPublicArticleById,
  fetchPublicArticle,
  selectPublicArticleBySlugOrId
} from 'app/store/marketing/publicArticlesSlice';
import { selectIsLoading } from 'app/store/utilSlice';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

export default function Article() {
  const routeParams = useParams();
  const dispatch = useDispatch();
  const article = useSelector(selectPublicArticleBySlugOrId(routeParams.id));
  const isLoading = useSelector(selectIsLoading);

  useEffect(() => {
    if (!article) {
      dispatch(fetchPublicArticle(routeParams.id));
    }
  }, [dispatch, routeParams.id, article]);

  return (
    <>
    {article && (
      <ArticleHeaderTags 
        title={article.title} 
        description={article.excerpt || article.title} 
        userAuthor={article.userAuthor}
        organizationAuthor={article.organizationAuthor}
        datePublished={article.createdAt} 
        image={article.headerImageUrl}
        article={article}
      />
    )}
    <div>
      {/* Breadcrumbs */}
      <section>
        <div className="container py-28">
          <Breadcrumbs
            trail={[
              { label: 'Home', to: '/' },
              { label: 'Articles', to: '/community-articles' },
              ...(article ? [{ label: article.title, to: `/article/${article.id}` }] : [])
            ]}
          />
        </div>
      </section>

      {/* Article content */}
      <section>
        <div className="container pb-20 lg:pb-80">
          {isLoading ? (
            <div className="flex justify-center py-32">
              <CircularProgress />
            </div>
          ) : (
            <ArticleViewContent article={article} mode="public" />
          )}
        </div>
      </section>
    </div>
    </>
  )
}